import { api } from './api';

// Função para retry com delay exponencial
const retryRequest = async (fn, maxRetries = 3) => {
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fn();
    } catch (error) {
      if (i === maxRetries - 1) throw error;
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        const delay = Math.pow(2, i) * 1000; // Delay exponencial: 1s, 2s, 4s
        console.log(`🔄 Tentativa ${i + 1} falhou, tentando novamente em ${delay}ms...`);
        await new Promise(resolve => setTimeout(resolve, delay));
      } else {
        throw error;
      }
    }
  }
};

export const dashboardService = {
  // Carregar chegadas próximas
  getUpcomingArrivals: async (params = {}) => {
    try {
      return await retryRequest(async () => {
        const response = await api.get('/reservations/upcoming-arrivals', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar chegadas próximas:', error);
      return [];
    }
  },

  // Carregar partidas próximas
  getUpcomingDepartures: async (params = {}) => {
    try {
      return await retryRequest(async () => {
        const response = await api.get('/reservations/upcoming-departures', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar partidas próximas:', error);
      return [];
    }
  },

  // Carregar atividade recente
  getRecentActivity: async (params = {}) => {
    try {
      return await retryRequest(async () => {
        const response = await api.get('/dashboard/recent-activity', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar atividade recente:', error);
      return [];
    }
  },

  // Carregar estatísticas do dashboard
  getDashboardStats: async (params = {}) => {
    try {
      return await retryRequest(async () => {
        const response = await api.get('/dashboard/stats', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar estatísticas:', error);
      return {
        totalReservations: 0,
        occupancyRate: 0,
        revenue: 0,
        pendingCheckins: 0
      };
    }
  },

  // Carregar dados de ocupação
  getOccupancyData: async (params = {}) => {
    try {
      return await retryRequest(async () => {
        const response = await api.get('/dashboard/occupancy', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar dados de ocupação:', error);
      return [];
    }
  },

  // Carregar dados de receita
  getRevenueData: async (params = {}) => {
    try {
      return await retryRequest(async () => {
        const response = await api.get('/dashboard/revenue', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar dados de receita:', error);
      return [];
    }
  },

  // Carregar dados de fontes de reserva
  getBookingSources: async (params = {}) => {
    try {
      return await retryRequest(async () => {
        const response = await api.get('/dashboard/booking-sources', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar fontes de reserva:', error);
      return [];
    }
  },

  // Carregar estatísticas rápidas
  getQuickStats: async (params = {}) => {
    try {
      return await retryRequest(async () => {
        const response = await api.get('/dashboard/quick-stats', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar estatísticas rápidas:', error);
      return {
        guestSatisfaction: 0,
        averageRating: 0,
        monthlyBookings: 0,
        averageDailyRate: 0
      };
    }
  },

  // Carregar dados de ocupação por período
  getOccupancyByPeriod: async (period = '7d', hotelId = null) => {
    try {
      return await retryRequest(async () => {
        const params = { period };
        if (hotelId) params.hotelId = hotelId;
        const response = await api.get('/dashboard/occupancy', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar dados de ocupação por período:', error);
      return [];
    }
  },

  // Carregar dados financeiros por período
  getFinancialData: async (period = '6m', hotelId = null) => {
    try {
      return await retryRequest(async () => {
        const params = { period };
        if (hotelId) params.hotelId = hotelId;
        const response = await api.get('/dashboard/financial', { params });
        return response.data;
      });
    } catch (error) {
      console.error('Erro ao carregar dados financeiros:', error);
      return [];
    }
  }
};
